/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SchedulePPD = {
    properties: {
        id: {
    type: 'number',
    isReadOnly: true,
},
        department_id: {
    type: 'number',
    isRequired: true,
},
        department_title_id: {
    type: 'number',
    isNullable: true,
},
        ppd: {
    type: 'number',
    isRequired: true,
    format: 'double',
},
        target_ppd: {
    type: 'number',
    isNullable: true,
    format: 'double',
},
        actual_work_hour: {
    type: 'number',
    isNullable: true,
    format: 'double',
},
        date: {
    type: 'string',
    isRequired: true,
    format: 'date',
},
        created_at: {
    type: 'string',
    isReadOnly: true,
    format: 'date-time',
},
        updated_at: {
    type: 'string',
    isReadOnly: true,
    format: 'date-time',
},
        archived_at: {
    type: 'string',
    isReadOnly: true,
    isNullable: true,
    format: 'date-time',
},
    },
};